module.exports = __webpack_public_path__ + "img/2.3bedbed5.png";